import React from 'react'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import RecommendationSF from '../../../components/superUser/loan/assessment/RecommendationSF'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import KeyFinancialsUI from '../../../components/superUser/loan/assessment/KeyFinancialsUI.js'

const RecommendationPageUI = ({ context, errorList, loan, account, loanFeasibility, feasibilityItemList,
  onRefreshClick,
  failed, total, failedSmallLoan, totalSmallLoan,
  keyFinancials, keyFinancialsList, transformedList
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_reco'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList || !loanFeasibility} loan={loan} page='recommendation'
    dimension='w768'
  >
    {
      (!loan && !errorList || !loanFeasibility) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan && loanFeasibility &&
      <div>
        {
          loanFeasibility &&
          <RecommendationSF
            context={context}
            loan={loan}
            account={account}
            loanFeasibility={loanFeasibility}
            feasibilityItemList={feasibilityItemList}
            failed={failed}
            total={total}
            failedSmallLoan={failedSmallLoan}
            totalSmallLoan={totalSmallLoan}
            onRefreshClick={onRefreshClick}
          />
        }
        <KeyFinancialsUI
          context={context} loan={loan}
          keyFinancials={keyFinancials}
          keyFinancialsList={keyFinancialsList}
          transformedList={transformedList}
        />
      </div>
    }
  </SuperUserLoanPageUI>

export default RecommendationPageUI
